import axios from 'axios';
import type { INotificationSettings } from '@bb/domain/dist/types';
import type { LocationsDTO } from '@bb/domain/dist/types/dto/OrgController/locations';

const getNotificationSettingsByUnsubscribeId = async (
  unsubscribeId: string,
) => {
  const { data } = await axios.get<{
    email: string;
    firstName: string;
    lastName: string;
    notifications: INotificationSettings;
    locations: LocationsDTO['locations'];
    enableNetwork: boolean;
    isLicensed: boolean;
    hasSmsFeature: boolean;
  }>(`/unsubscribe/${unsubscribeId}`);

  return data;
};

export default getNotificationSettingsByUnsubscribeId;
